import { render, staticRenderFns } from "./PaymentSimulator.vue?vue&type=template&id=5279bfbc&scoped=true&"
import script from "./PaymentSimulator.vue?vue&type=script&lang=js&"
export * from "./PaymentSimulator.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSimulator.vue?vue&type=style&index=0&id=5279bfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279bfbc",
  null
  
)

export default component.exports